module.exports = __webpack_public_path__ + "static/header-437f78bb4f26ab2f4ec8a7e2ffc6b0e3.jpg";